"use client";

import { TooltipProvider } from "@/components/ui/Tooltip";
import { CONSTANTS } from "@/constants";
import { NavigationProvider } from "@/contexts/NavigationContext";
import { ClerkProvider } from "@clerk/nextjs";
import { GoogleTagManager } from "@next/third-parties/google";
import { DirectionProvider } from "@radix-ui/react-direction";
import {
  isServer,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { Toaster } from "sonner";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 86400000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}

export default function Providers({ children }: { children: React.ReactNode }) {
  const locale = useLocale();
  const queryClient = getQueryClient();

  return (
    <ClerkProvider
      appearance={{
        variables: {
          colorPrimary: "#00b9a0",
          colorText: "#333333",
          fontSize: "1",
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <NavigationProvider>
          <GoogleTagManager gtmId={CONSTANTS.GTM_ID!} />
          <TooltipProvider>
            <DirectionProvider dir={locale === "ar" ? "rtl" : "ltr"}>
              {children}
            </DirectionProvider>
            <Toaster richColors />
          </TooltipProvider>
        </NavigationProvider>
      </QueryClientProvider>
    </ClerkProvider>
  );
}
